import { render, staticRenderFns } from "./THGTagForm.vue?vue&type=template&id=d95a005a&scoped=true"
import script from "./THGTagForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGTagForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGTagForm.vue?vue&type=style&index=0&id=d95a005a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95a005a",
  null
  
)

export default component.exports